let AlumniCompanies = 
[
    {
        name: 'McKinsey',
        href: 'https://www.mckinsey.com/',
        fileName: 'mckinsey.png'
    },
    {
        name: 'Bain',
        href: 'http://www.bain.com/',
        fileName: 'bain.png'
    },
    {
        name: 'BCG',
        href: 'https://www.bcg.com/',
        fileName: 'bcg.png'
    },
    
    {
        name: 'Deloitte',
        href: 'https://www2.deloitte.com/us/en.html',
        fileName: 'deloitte.png'
    },
    {
        name: 'PWC',
        href: 'http://www.pwc.com/',
        fileName: 'pwc.png'
    },
    {
        name: 'EY Parthenon',
        href: 'https://www.ey.com/en_us/strategy/about-ey-parthenon',
        fileName: 'eyp.png'
    },
    {
        name: 'Apple',
        href: 'https://www.apple.com/',
        fileName: 'apple.png'
    },
    {
        name: 'Google',
        href: 'https://www.google.com/',
        fileName: 'google.png'
    },
    {
        name: 'Meta',
        href: 'https://about.meta.com/',
        fileName: 'meta.png'
    },
    {
        name: 'Salesforce',
        href: 'https://www.salesforce.com/',
        fileName: 'salesforce.png'
    },
    {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/',
        fileName: 'linkedin.png'
    },
    {
        name: 'Amazon',
        href: 'https://www.amazon.com/',
        fileName: 'amazon.png'
    },
    {
        name: 'AirBnB',
        href: 'https://www.airbnb.com/',
        fileName: 'airbnb.png'
    },
    {
        name: 'Slack',
        href: 'https://slack.com/',
        fileName: 'slack.png'
    },
    {
        name: 'Scale',
        href: 'https://scale.com/',
        fileName: 'scale.png'
    },
    {
        name: 'Robinhood',
        href: 'https://robinhood.com/',
        fileName: 'robinhood.png'
    },
    {
        name: 'Lyft',
        href: 'https://www.lyft.com/',
        fileName: 'lyft.png'
    },
    {
        name: 'Uber',
        href: 'http://www.uber.com/',
        fileName: 'uber.png'
    },
    {
        name: 'Figma',
        href: 'https://www.figma.com/',
        fileName: 'figma.png'
    },  
    {
        name: 'Tesla',
        href: 'https://www.tesla.com/',
        fileName: 'tesla.png'
    },
    {
        name: 'Square',
        href: 'https://squareup.com/',
        fileName: 'square.png'
    },
    {
        name: 'Kiva',
        href: 'https://www.kiva.org/',
        fileName: 'kiva.png'
    },
    {
        name: 'Teach for America',
        href: 'https://www.teachforamerica.org/',
        fileName: 'tfa.png'
    },
    {
        name: 'REDF',
        href: 'http://www.redf.org/',
        fileName: 'redf.png'
    },
    {
        name: 'Blackstone',
        href: 'https://www.blackstone.com/',
        fileName: 'blackstone.png'
    },
    {
        name: 'Goldman Sachs',
        href: 'https://www.goldmansachs.com/',
        fileName: 'goldman.png'
    },
    {
        name: 'JP Morgan & Chase',
        href: 'https://www.jpmorganchase.com/',
        fileName: 'jp.png'
    },
    {
        name: 'KKR',
        href: 'https://www.kkr.com/',
        fileName: 'kkr.png'
    },
    {
        name: 'Centerview',
        href: 'http://www.centerviewpartners.com/',
        fileName: 'centerview1.png'
    },
    {
        name: 'NASA',
        href: 'https://www.nasa.gov/',
        fileName: 'nasa.png'
    },
    {
        name: 'Harvard Business School',
        href: 'https://www.hbs.edu/Pages/default.aspx',
        fileName: 'hbs.png'
    },
    {
        name: 'Stanford Business School',
        href: 'https://www.gsb.stanford.edu/',
        fileName: 'stanford.png'
    },
    {
        name: 'Wharton',
        href: 'https://www.wharton.upenn.edu/',
        fileName: 'wharton.png'
    },
    {
        name: 'Cambridge',
        href: 'https://www.cam.ac.uk/',
        fileName: 'cambridge.png'
    },
    {
        name: 'Columbia Law',
        href: 'https://www.law.columbia.edu/',
        fileName: 'col_law.png'
    },
    {
        name: 'UC San Francisco',
        href: 'https://www.ucsf.edu/',
        fileName: 'ucsf.png'
    },
    
    
];

export default AlumniCompanies;